/*=========================================================================================
  File Name: moduleCompanyGetters.js
  Description: Company Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	getVisitPonitById: (state) => (visitPointId) =>
		state.visitPoints.find((visitPoint) => visitPoint.id == visitPointId),
	getCurrentVisitPoint: (state) => state.currentVisitPoint,
};
